import React from 'react';

import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';

import BusinessUnitSelector from 'components/common/BusinessUnitsSelector';

import NewPromptSectionButton from './components/NewPromptSectionButton';
import PromptBuilder from './components/PromptBuilder';
import PromptSectionsForBusinessUnit from './components/PromptSectionsForBusinessUnit';

const PromptSections = () => {
  const [businessUnitId, setBusinessUnitId] = React.useState<number | null>(null);
  const [refetchFlag, setRefetchFlag] = React.useState<number>(0);
  const [useNewInterface, setUseNewInterface] = React.useState<boolean>(true);

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" m={2} alignItems="center">
        <Box>
          <Typography variant="h4">Personaliza a tu Agente</Typography>
          <Typography variant="subtitle1">
            {useNewInterface
              ? 'Personaliza el prompt de tu Agente con el constructor visual de prompts'
              : 'Personaliza el prompt de tu Agente con el editor de texto'}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" gap={2}>
          {/* Toggle between old and new interface */}
          <Box display="flex" alignItems="center">
            <Typography variant="body2">Vista tabla</Typography>
            <Switch checked={useNewInterface} onChange={(e) => setUseNewInterface(e.target.checked)} color="primary" />
            <Typography variant="body2">Constructor visual</Typography>
          </Box>

          {businessUnitId && (
            <NewPromptSectionButton businessUnitId={businessUnitId} refetch={() => setRefetchFlag(refetchFlag + 1)} />
          )}

          <BusinessUnitSelector
            businessUnitId={businessUnitId}
            setBusinessUnitId={setBusinessUnitId}
            disableAllBusinessUnitsOption
            selectItemIfOnlyOne
          />
        </Box>
      </Box>

      {/* Content based on selected interface */}
      {businessUnitId ? (
        <Box m={useNewInterface ? 0 : 2}>
          {useNewInterface ? (
            <PromptBuilder businessUnitId={businessUnitId} refetchFlag={refetchFlag} />
          ) : (
            <PromptSectionsForBusinessUnit refetchFlag={refetchFlag} businessUnitId={businessUnitId} />
          )}
        </Box>
      ) : (
        <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
          <Typography variant="h5">
            Selecciona una unidad de negocio para ver la información que Zeller tiene disponible
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default PromptSections;
